
import { ComponentCreator, createComponentCreator, styleInject } from 'packages/css-component-modules';

const _css = `.Cta_488518a714f2259f{display:flex;flex-direction:row;align-items:center}.Cta_488518a714f2259f.padding_5bda17ef47f51774{padding:0 16px}.Helper_3077b05035c91a85{line-height:16px;font-weight:700;display:flex;margin-bottom:0}.Helper_3077b05035c91a85.padding_5bda17ef47f51774{padding:16px 0}.Chevron_6efc8efc48c612fd{display:inherit;margin-left:5px}@media (min-width:600px),(orientation:landscape){.Cta_488518a714f2259f.padding_5bda17ef47f51774{padding:0 32px}}`;
styleInject(_css)

/** Cta Props */
export type CtaCCM = {
  /** Cta Component Custom Properties */
  // No custom properties found

  /** Cta Modifier Flags */
  '$padding'?: boolean;
};
/** Base Cta component */
export const Cta: ComponentCreator<CtaCCM> = createComponentCreator({
  "name": "Cta",
  "base": "Cta_488518a714f2259f",
  "prop": {},
  "mod": {
    "$padding": "padding_5bda17ef47f51774"
  }
});


/** Helper Props */
export type HelperCCM = {
  /** Helper Component Custom Properties */
  // No custom properties found

  /** Helper Modifier Flags */
  '$padding'?: boolean;
};
/** Base Helper component */
export const Helper: ComponentCreator<HelperCCM> = createComponentCreator({
  "name": "Helper",
  "base": "Helper_3077b05035c91a85",
  "prop": {},
  "mod": {
    "$padding": "padding_5bda17ef47f51774"
  }
});


/** Chevron Props */
export type ChevronCCM = {
  /** Chevron Component Custom Properties */
  // No custom properties found

  /** Chevron Modifier Flags */
  // No modifiers classes found
};
/** Base Chevron component */
export const Chevron: ComponentCreator<ChevronCCM> = createComponentCreator({
  "name": "Chevron",
  "base": "Chevron_6efc8efc48c612fd",
  "prop": {},
  "mod": {}
});

